// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-image-absolute {
    position: absolute;
    top: 5 !important;
    right: 0;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/modals/addEditHealtCategory/AddEditHealthCategoryModal.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,QAAQ;IACR,eAAe;AACnB","sourcesContent":[".edit-image-absolute {\n    position: absolute;\n    top: 5 !important;\n    right: 0;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
